import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/dist/query/react";
import {catchResponse, prepareFetchRequest} from "./common.service";
import {IResDocuments} from "./response.interface";
import moment from "moment";
import {IReqDocuments} from "./request.interface";


export const documentsAPI = createApi({
    reducerPath: 'documentsAPI',
    baseQuery: fetchBaseQuery(prepareFetchRequest()),
    tagTypes: ['documents'],
    endpoints: (build) => ({
        fetchAllDocuments: build.query<IResDocuments, IReqDocuments>({
            async queryFn({
                locale,
                fromDate = moment().format('YYYY-MM-01'),
                toDate = moment().format('YYYY-MM-DD'),
                holderId,
                page = 0,
                limit = 5
            }, {getState, dispatch}, extraOptions, fetchWithBQ) {

                const result = await fetchWithBQ({
                    url: `/common/docs`, params: {
                        lang: locale, fromDate, toDate, holderId, page, limit
                    }
                });

                catchResponse({data: result.data, meta: result.meta, getState, dispatch});

                let data = result.data as IResDocuments;
                data.docs = data.docs.map(doc => ({
                    ...doc,
                    amount: doc.docHeaders?.amount || '-',
                    quantity: doc.docHeaders?.quantity || '-'
                }))

                return {data}

            }, providesTags: result => ['documents']
        })

    })
});

export const {} = documentsAPI;
